import React, { useState, useEffect } from 'react'
import { Table, Panel, ButtonGroup } from 'rsuite'

export default function ScreenHistory({ schema, header, onPreview, ...props }) {
  const { Column, HeaderCell, Cell } = Table
  console.log('schema', schema)
  return (
    <>
      <Panel header={header} bordered collapsible shaded defaultExpanded>
        <Table
          wordWrap
          height={400}
          data={schema?.tableData || []}
          onRowClick={(data) => {
            console.log(data)
          }}
        >
          <Column width={150}>
            <HeaderCell align="center">
              <span>{schema?.dateTimeTitle}</span>
            </HeaderCell>
            <Cell dataKey="dateTime" />
          </Column>
          <Column width={150}>
            <HeaderCell align="center">
              <span>{schema?.agencyTitle}</span>
            </HeaderCell>
            <Cell dataKey="agency" />
          </Column>
          <Column width={150}>
            <HeaderCell align="center">
              <span>{schema?.screenTypeTitle}</span>
            </HeaderCell>
            <Cell dataKey="screenType" />
          </Column>
          <Column width={160}>
            <HeaderCell align="center">
              <span>{schema?.screenerTitle}</span>
            </HeaderCell>
            <Cell dataKey="screener" />
          </Column>
          <Column width={160}>
            <HeaderCell align="center">
              <span>{schema?.coordinatorTitle}</span>
            </HeaderCell>
            <Cell dataKey="coordinator" />
          </Column>

          <Column flexGrow={1} width={300}>
            <HeaderCell align="center">
              <span>{schema?.commentTitle}</span>
            </HeaderCell>
            <Cell dataKey="comment" />
          </Column>
        </Table>
      </Panel>
    </>
  )
}
